module.exports = __webpack_public_path__ + "img/picNewversionPopup@2x.6e51a956.png";